"use client";

import { Suspense, useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";

const PIXEL_ID = "1886948638620648";

function MetaPixelTracker() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    import("react-facebook-pixel")
      .then((ReactPixel) => {
        ReactPixel.default.init(PIXEL_ID, undefined, {
          autoConfig: true,
          debug: false,
        });
        ReactPixel.default.pageView();
      })
      .catch((error) => {
        console.warn("[MetaPixel] Initialization failed:", error);
      });
  }, []);

  useEffect(() => {
    import("react-facebook-pixel")
      .then((ReactPixel) => ReactPixel.default.pageView())
      .catch((error) => {
        console.warn("[MetaPixel] PageView tracking failed:", error);
      });
  }, [pathname, searchParams]);

  return null;
}

export default function MetaPixelInit() {
  return (
    <Suspense fallback={null}>
      <MetaPixelTracker />
    </Suspense>
  );
}
